
































/**
 * 级联组件单选
 */
import { cloneDeep } from 'lodash';
import { NO_LIMIT } from './../const/fastCreation';
import Popup from '@/components/popup/popup.vue';
import {
  defineComponent,
  ref,
  watch,
  toRefs,
} from 'vue-demi';


// tree组件暴露的值节点
interface TreeValueNode {
  value: string | number;
  children?: TreeValueNode[];
  status: 'all' | 'partial';
}
export default defineComponent({
  name: 'popup-tree',
  components: {
    Popup
  },
  props: {
    show: {
      type: Boolean,
      default: false,
      required: true
    },
    title: {
      type: String,
      default: ''
    },
    value: {
      type: Array,
      default: () => []
    },
    options: {
      type: Array,
      default: () => []
    },
    dynamicHeader: {
      type: Boolean,
      default: false,
      required: false
    },
    search: {
      type: String,
      default: ''
    }
  },
  setup(props, { emit }) {
    const selectedSet = ref(new Set());
    const localOptions = ref([]);
    const treeRef = ref(null);
    const { show, value, search } = toRefs(props);


    watch(
      () => value.value,
      () => {
        treeRef.value?.setCheckedKeys(value.value);
      }
    );
    watch(
      () => show.value,
      () => {
        setTimeout(() => {
          if (show.value) {
            treeRef.value?.setCheckedKeys(props.value);
          }

        }, 0);
      }
    );
    watch(
      () => search.value,
      () => {
        if (!search.value) {
          localOptions.value = cloneDeep(props.options);
        }
        treeRef.value?.filter(search.value);
      }
    );
    watch(
      () => props.options,
      (newVal, oldVal) => {
        if ((oldVal.length === 0 && newVal.length !== 0) || oldVal.length === newVal.length) {
          localOptions.value = props.options;
          selectedSet.value = new Set(props.value);
          treeRef.value?.setCheckedKeys(props.value);
          return;
        }
        treeRef.value?.setCheckedKeys(props.value);
      }
    );
    const filterNode = (value, data) => {
      if (!value) {
        return true;
      }
      return data.label.toLowerCase().includes(value.toLowerCase());
    };
    const handleCheckChange = (data, checked) => {
      if (data?.id === 'NO_LIMIT' && checked) {
        selectedSet.value = new Set(['NO_LIMIT']);
        treeRef.value.setCheckedKeys([NO_LIMIT.value]);
        return;
      }
      if (checked) {
        selectedSet.value.add(data.value);
      } else {
        selectedSet.value.delete(data.value);
      }
      if (selectedSet.value.size === 0) {
        treeRef.value.setCheckedKeys([NO_LIMIT.value]);
      } else if (selectedSet.value.has(NO_LIMIT.value) && selectedSet.value.size !== 1) {
        selectedSet.value.delete(NO_LIMIT.value);
        treeRef.value.setCheckedKeys(selectedSet.value);
      }
    };

    const handleConfirm = () => {
      const allSelectedKeys = treeRef.value.getThroughedKeys().flat();
      const halfCheckedKeys = treeRef.value.getHalfCheckedKeys();
      const getPassedKeys = allSelectedKeys.filter(key => !halfCheckedKeys.includes(key));
      emit('close');
      emit('confirm', {
        mergedValues: [...Array.from(getPassedKeys)],
        throughedValues: allSelectedKeys
      });
    };

    return {
      treeRef,
      filterNode,
      handleCheckChange,
      localOptions,
      handleConfirm,
    };
  }
});
